import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PageTransition from "./components/PageTransition";
import MiniPlayer from "./components/MiniPlayer";
import ListenFab from "./components/ListenFab";
import Home from "./pages/Home";
import About from "./pages/About";
import Work from "./pages/Work";
import GameCredits from "./pages/GameCredits";
import FilmCredits from "./pages/FilmCredits";
import Contact from "./pages/Contact";
import Music from "./pages/Music";
import { Toaster } from "./components/ui/toaster";
import { PlayerProvider } from "./context/PlayerContext";

function App() {
  useEffect(() => {
    document.title = "LRRC | Professional Composer and Audio Specialist";
  }, []);

  return (
    <div className="App min-h-screen bg-[#f4f1ec]">
      <BrowserRouter>
        <PlayerProvider>
          <Navbar />
          <PageTransition>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/music" element={<Music />} />
              <Route path="/about" element={<About />} />
              <Route path="/work" element={<Work />} />
              <Route path="/work/game-credits" element={<GameCredits />} />
              <Route path="/work/film-credits" element={<FilmCredits />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </PageTransition>
          <Footer />
          <ListenFab />
          <MiniPlayer />
          <Toaster />
        </PlayerProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
